export type TPatientOption = {
  uuid: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export type TMessageConversationListItem = {
  conversationUuid: string;
  patientUuid?: string | null;
  participantE164: string;
  clinicOwnedE164?: string | null;
  patientLabel?: string | null;
  lastMessagePreview?: string | null;
  lastMessageAt?: string | null;
  unreadCount?: number;
  isRead?: boolean;
  readAt?: string | null;
};

export type TMessageSaveStatusFilter = "saved" | "unsaved";

export type TCommunicationsUiState =
  | "communications_not_initialized"
  | "communications_activating"
  | "communications_active_with_included_number"
  | "communications_active_with_extra_numbers";

export const DEFAULT_TO_COUNTRY_CODE = "+1";
export const CALLS_PAGE_SIZE = 50;

export const ASSIGN_PHONE_ALREADY_SET_MESSAGE =
  "Patient phone number is already set. Pass overwrite_existing_phone_number=true to replace it.";
export const ASSIGN_PHONE_OVERWRITE_PROMPT_MESSAGE =
  "This patient already has a phone number. Overwrite it with this call's number?";
export const COMMUNICATIONS_SEAT_BILLING_COPY =
  "$5 / communication-enabled ClinicUser / month";
export const COMMUNICATIONS_PATIENT_DISABLED_REASON =
  "Patient users cannot be communication-enabled.";

export const DEFAULT_INCLUDED_MINUTES = 500;
